module.exports = __webpack_public_path__ + "img/Gallery_2_24.69fa8277.jpeg";